"use client";

import styled, { css } from "styled-components";
import { sans as zoram, fontSize13, lineHeightTight, fontWeightNormal } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
export const internalUseOnlyPriority6 = css(["margin:0;font-family:", ";font-weight:", ";font-size:", ";line-height:", ";"], zoram, fontWeightNormal, fontSize13, lineHeightTight);
const H6Styled = styled.h6.withConfig({
  componentId: "sc-1r3sor6-0"
})(["", ";"], internalUseOnlyPriority6);

/**
 * The sixth level heading style. You can override the semantics by passing a different `renderAs` prop to still look like an `h6` but be an `h5` (or other heading) if needed.
 * @param {object} props - The component props
 * @param {React.ReactNode} props.children - The content inside the heading
 * @param {React.ElementType} [props.renderAs] - The HTML tag string (e.g., `"div"`) or React component to render
 * @returns {React.ReactNode} The H6 component
 */
const H6 = ({
  children,
  renderAs,
  ...props
}) => /*#__PURE__*/_jsx(H6Styled, {
  as: renderAs,
  ...props,
  children: children
});
H6.displayName = "H6";
export default H6;